import * as actionTypes from '../../../constants/actionTypes'

const initState = {
    list: [],
    menu: true,
    navigation: 0,
    redirect: false,
    toastMessage: '',
    loadingPage: true,
    loadingBtn: false,
    redirectId: false,
    toastStatus: false,
    loadingBackdrop: true,
}

const commonReducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.LIST: return { ...state, list: action.payload }
        case actionTypes.MENU: return { ...state, menu: action.payload }
        case actionTypes.NAVIGATION: return { ...state, navigation: action.payload }
        case actionTypes.LOADING_BTN: return { ...state, loadingBtn: action.payload }
        case actionTypes.LOADING_PAGE: return { ...state, loadingPage: action.payload }
        case actionTypes.LOADING_BACKDROP: return { ...state, loadingBackdrop: action.payload }
        case actionTypes.SNACKBAR:
            return {
                ...state,
                toastStatus: action.payload.status,
                toastMessage: action.payload.message
            }
        case actionTypes.REDIRECT:
            return {
                ...state,
                redirect: action.payload,
                redirectId: action.id || false
            }
        default: return state
    }
}

export default commonReducer
